import React, { createContext, useContext, useRef, ReactNode } from "react";

type ScrollContextType = {
  scrollRef: React.RefObject<HTMLDivElement>;
  scrollToTop: () => void;
};

const ScrollContext = createContext<ScrollContextType | undefined>(undefined);

export function ScrollProvider({ children }: { children: ReactNode }) {
  const scrollRef = useRef<HTMLDivElement>(null);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <ScrollContext.Provider value={{ scrollRef, scrollToTop }}>
      {children}
    </ScrollContext.Provider>
  );
}

export function useScroll(): ScrollContextType {
  const context = useContext(ScrollContext);
  if (!context) {
    throw new Error("useScroll deve ser usado dentro de ScrollProvider");
  }
  return context;
}